import React from 'react'

import clsx from 'clsx'

import Paper from 'components/Paper'

import classes from './ContentTable.module.scss'

const ContentTable = ({ title, contentTable: content }) => {
  const [headers, ...body] = content.tableData

  return (
    <div className={clsx('ContentTable', classes.root)}>
      {title ? (
        <h4>
          <span>{title}</span>
        </h4>
      ) : (
        ''
      )}
      <Paper className={classes.container}>
        <table className={classes.table}>
          <thead className={classes.tableHead}>
            <tr>
              {headers.map(header => (
                <th key={header} className={clsx(classes.head, classes.cell)}>
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className={classes.tableBody}>
            {body.map(row => (
              <tr key={row} className={clsx(classes.tableBaseRow, classes.row)}>
                {row.map((cell, index) => (
                  <th key={cell} className={clsx(classes.cell, classes[`i${index}`])}>
                    {cell}
                  </th>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </Paper>
    </div>
  )
}

export default ContentTable
